import React from 'react'
import {
  Box,
  Typography,
  Grid,
  Chip,
  Card,
  CardContent,
  CardMedia,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Divider,
  Link,
} from "@mui/material"


interface HbpCommonProps {
  hbpData: any 
}

function renderDescription(desc: string): React.ReactNode[] {
  const nodes: React.ReactNode[] = []
  const anchorRe = /<a\s+[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi

  const stripTags = (s: string) => s.replace(/<[^>]+>/g, "")

  const linkify = (text: string): React.ReactNode[] => {
    const parts: React.ReactNode[] = []
    const urlRe = /((https?:\/\/|www\.)[^\s<>"')]+)(?![^<]*>)/gi
    let last = 0
    let m: RegExpExecArray | null
    while ((m = urlRe.exec(text)) !== null) {
      const [url] = m
      const before = text.slice(last, m.index)
      if (before) parts.push(before)
      const href = url.startsWith("http") ? url : `https://${url}`
      parts.push(
        <Link key={`u-${last}-${m.index}`} href={href} target="_blank" rel="noopener noreferrer">
          {url}
        </Link>,
      )
      last = m.index + url.length
    }
    const tail = text.slice(last)
    if (tail) parts.push(tail)
    return parts
  }

  let lastIndex = 0
  let match: RegExpExecArray | null
  while ((match = anchorRe.exec(desc)) !== null) {
    const [full, href, inner] = match
    const before = desc.slice(lastIndex, match.index)
    if (before) nodes.push(...linkify(stripTags(before)))
    nodes.push(
      <Link key={`a-${match.index}`} href={href} target="_blank" rel="noopener noreferrer">
        {stripTags(inner)}
      </Link>,
    )
    lastIndex = match.index + full.length
  }
  const rest = desc.slice(lastIndex)
  if (rest) nodes.push(...linkify(stripTags(rest)))

  return nodes
}

function getHbp(response : any) {
  try {
  if (response.apiDataEntities && Array.isArray(response.apiDataEntities)) {
    for (const entity of response.apiDataEntities) {
      if (entity.data && entity.data.emailSearchResultHbp) {
        return entity.data.emailSearchResultHbp
      }
    }
  }
  return null
} catch (e) {

}
}

const Hbp: React.FC<HbpCommonProps> = ({ hbpData }) => {
  const filteredArray = getHbp(hbpData)

  return (
    <Box display="flex" flexDirection="column" gap={4}>
      {filteredArray.map((item: any, idx: any) => (
        <Box key={idx}>
          <Divider sx={{ my: 3 }} />
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <CardMedia
              component="img"
              image={item?.LogoPath}
              alt={item?.Name}
              sx={{ width: 60, height: 60, objectFit: "contain" }}
            />
            <Typography variant="h5">{item?.Title}</Typography>
          </Box>

          <Table size="small" sx={{ maxWidth: 600 }}>
            <TableBody>
              <TableRow>
                <TableCell><b>Domain</b></TableCell>
                <TableCell>{item?.Domain}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><b>Breach Date</b></TableCell>
                <TableCell>{item?.BreachDate}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><b>Added</b></TableCell>
                <TableCell>{new Date(item?.AddedDate).toLocaleDateString()}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><b>Modified</b></TableCell>
                <TableCell>{new Date(item?.ModifiedDate).toLocaleDateString()}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><b>Accounts affected</b></TableCell>
                <TableCell>{item?.PwnCount?.toLocaleString()}</TableCell>
              </TableRow>
              
                { item?.Description && (
                <TableRow>
                <TableCell><b>Description</b></TableCell>
                <TableCell sx={{ whiteSpace: "pre-line" }}>
                  {renderDescription(item?.Description)}
                </TableCell>
              </TableRow>
                )
                }
            </TableBody>
          </Table>

          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1.5} sx={{ mt: 2 }}>
            {item?.DataClasses?.map((dc: any, i: any) => (
              <Chip key={i} label={dc} color="error" variant="outlined" />
            ))}
          </Stack>
          <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ mt: 2 }}>
            {[
              "IsVerified",
              "IsFabricated",
              "IsSensitive",
              "IsRetired",
              "IsSpamList",
              "IsMalware",
              "IsSubscriptionFree",
              "IsStealerLog",
            ].map((field) => (
              <Chip
                key={field}
                label={`${field}: ${item[field as keyof typeof item] ? "true" : "false"}`}
                color={item[field as keyof typeof item] ? "success" : "default"}
                variant="outlined"
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Box>
  )
}

export default Hbp